import { z } from 'zod';
import { c } from '../../contract';

export const adjustRouter = c.router(
  {
    install: {
      summary: 'Receives a request form Adjust when mobile app is installed',
      method: 'GET',
      path: '/install',
      query: z.object({
        adid: z.string(),
        tracker: z.string(),
        activity_kind: z.string(),
        tracker_name: z.string(),
        environment: z.string().optional(),
        platform: z.string().optional(),
        campaign_name: z.string().optional(),
        os_name: z.string().optional(),
        click_referer: z.string().optional(),
        android_id: z.string().optional(),
        partner_parameters: z.string().optional(),
        label: z.string().optional(),
        fb_install_referrer: z.string().optional(),
        meta_install_referrer: z.string().optional(),
        referrer: z.string().optional(),
        market_referrer_gclid: z.string().optional(),
        app_name: z.string().optional(),
        app_version: z.string().optional(),
        device_manufacturer: z.string().optional(),
        hardware_name: z.string().optional(),
        installed_at: z.string().optional(),
        network_tracker: z.string().optional(),
        app_id: z.string().optional(),
        deeplink: z.string().optional(),
        device_model: z.string().optional(),
        device_name: z.string().optional(),
        device_type: z.string().optional(),
        language: z.string().optional(),
        os_version: z.string().optional(),
        sdk_version: z.string().optional(),
        web_uuid: z.string().optional(),
        /**
         * MD5 hash of the `external_device_id` set on the Adjust SDK (we set
         * this to the Firebase uid via `Adjust.setExternalDeviceIdInDelay`).
         * Populated by the `{external_device_id_md5}` placeholder configured
         * on the Adjust install callback URL.
         * See: https://help.adjust.com/en/article/external-device-identifiers
         * DEV-4113.
         */
        md5: z.string().optional(),
        /* Facebook Click ID */
        dcp_fbclid: z.string().optional(),
        /* Facebook Pixel ID */
        dcp_fpid: z.string().optional(),
        dcp_original_referrer: z.string().optional(),
      }),
      responses: {
        200: z.literal('OK'),
      },
    },
  },
  { pathPrefix: '/adjust-events' },
);
